import { render } from "./ToolsPage.vue?vue&type=template&id=b3be7312&scoped=true"
import script from "./ToolsPage.vue?vue&type=script&lang=js"
export * from "./ToolsPage.vue?vue&type=script&lang=js"

import "./ToolsPage.vue?vue&type=style&index=0&id=b3be7312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3be7312"]])

export default __exports__